import { render, staticRenderFns } from "./editProduction.vue?vue&type=template&id=38012c3c&scoped=true&"
import script from "./editProduction.vue?vue&type=script&lang=js&"
export * from "./editProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38012c3c",
  null
  
)

export default component.exports